import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { PointsService } from 'src/app/services/points.service';

import { SelectCoordinatePointsControlService } from '../services/select-coordinate-points-control.service';

import { ProcedureModel } from 'src/app/models/procedure';
import { ProcedureLegModel } from 'src/app/models/procedure-leg';
import { ProcedureCoordinatePoint, ProcedureCoordinatePointModel } from 'src/app/models/procedure-coordinate-point';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { cloneDeep } from 'lodash';
import { MapService } from 'src/app/services/map.service';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { AirspaceBoundariesControlService } from 'src/app/services/airspace-boundaries-control.service';
import { AirSpaceBoundaryCoordinatePointModel } from 'src/app/models/air-space-boundary-coordinate-point';

@Component({
  selector: 'app-select-coordinate-point',
  templateUrl: './select-coordinate-point.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class SelectCoordinatePointComponent implements OnInit {

  isFromAirSpaceBoundary : boolean;
  @Input() createProcedureTempID: number;

  @Input() airspaceService: AirspaceBoundariesControlService;
  constructor(private bsModalRef : BsModalRef,
    private pointsController : PointsService,
    public selectCoordinatePointService : SelectCoordinatePointsControlService,
    private mapService : MapService,
    private vicentyService : VicentyToolControlService,
    ) {}

  ngOnInit(): void {
    this.isFromAirSpaceBoundary = this.selectCoordinatePointService.isFromAirSpaceBoundary;
    if(!this.selectCoordinatePointService.activeChangeAirport){
      this.selectCoordinatePointService.coordinatePointsModal[1].published = true;
      //let emptyCoordPoint: CoordinatePointModel = new CoordinatePointModel();
      this.selectCoordinatePointService.coordinatePointsModal[0].coordpointid = "New ID";
      this.selectCoordinatePointService.coordinatePointsModal[0].name = "Click Position";
      this.selectCoordinatePointService.coordinatePointsModal[0].empty = true;
      if (this.isFromAirSpaceBoundary){
        this.selectCoordinatePointService.coordinatePointsModal[0].type = "AIRSPACE_BOUNDARY_VERTEX";
      } else {
        this.selectCoordinatePointService.coordinatePointsModal[0].type = "WAYPOINT";
      }
      this.selectCoordinatePointService.coordinatePointsModal[0].nominalaltitude = 0;
      this.selectCoordinatePointService.coordinatePointsModal[0].published = false;
      //emptyCoordPoint.longitude = this.selectCoordinatePointService.coordinatePointsModal[0].longitude;
      //emptyCoordPoint.latitude = this.selectCoordinatePointService.coordinatePointsModal[0].latitude;
      //this.selectCoordinatePointService.coordinatePointsModal.slice(0,1);

      //this.selectCoordinatePointService.coordinatePointsModal.push(emptyCoordPoint);

    }


     // }
    //}
  }

  addCoordinatePoint() : void {
    this.selectCoordinatePointService.coordinatePointsModal.forEach( elm => {
      if(elm.isselected){
        let index = 0;
        elm.isselected = false;
        if(this.selectCoordinatePointService.activeChangeAirport){
          this.selectCoordinatePointService.activeChangeAirport = false;
          this.selectCoordinatePointService.selectedAirport = elm;
          return;
        }
        if(this.selectCoordinatePointService.airSpaceBoundaryActive){
          let airspaceCP : AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();
          airspaceCP.coordPoint = elm;
          this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.push(airspaceCP)
          this.airspaceService.drawLegs();
          return;
        }
        if(this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.length > 0){
         if (this.selectCoordinatePointService.activeChangeStartPoint) {
            this.selectCoordinatePointService.activeChangeStartPoint = false;

            let newPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
            newPoint.altitude = 0;
            newPoint.coordPoint = elm;



            //const indexCoordPoint = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.findIndex(elm => elm.procedureCoordPointPk == this.selectCoordinatePointService.selectedProcedureLeg.startPoint.procedureCoordPointPk);
            const indexCoordPoint = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.findIndex(pcp =>
              this.selectCoordinatePointService.selectedProcedureLeg.startPoint.sequencenumber == pcp.sequencenumber);
            if (indexCoordPoint > -1) {
              newPoint.sequencenumber = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints[indexCoordPoint].sequencenumber;
              this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.splice(indexCoordPoint, 1, newPoint);
            }

            //let indexProcedureLeg = this.selectCoordinatePointService.selectedProcedure.procedureLegs.indexOf(this.selectCoordinatePointService.selectedProcedureLeg, 0);
            const indexProcedureLeg = this.selectCoordinatePointService.selectedProcedure.procedureLegs.findIndex(
              leg => leg.procedurelegid == this.selectCoordinatePointService.selectedProcedureLeg.procedurelegid);
            if (indexProcedureLeg == 0) {// first
              this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
              let newLeg : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
              newLeg.startPointId = null;
              newLeg.startPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg);
              this.selectCoordinatePointService.selectLegFeature(newLeg, this.selectCoordinatePointService.selectedProcedure);
            } else if (indexProcedureLeg == this.selectCoordinatePointService.selectedProcedure.procedureLegs.length - 1) {// last

              this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg - 1].ismodified = true;
              let newLeg1 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg - 1]);
              newLeg1.endPointId = null;
              newLeg1.endPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg1, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg1);
              this.selectCoordinatePointService.selectLegFeature(newLeg1, this.selectCoordinatePointService.selectedProcedure);

              this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
              let newLeg2 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
              newLeg2.startPointId = null;
              newLeg2.startPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg2, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg2);
              this.selectCoordinatePointService.selectLegFeature(newLeg2, this.selectCoordinatePointService.selectedProcedure);
            } else {// in between
              this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg - 1].ismodified = true;
              let newLeg1 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg - 1]);
              newLeg1.endPointId = null;
              newLeg1.endPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg1, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg1);
              this.selectCoordinatePointService.selectLegFeature(newLeg1, this.selectCoordinatePointService.selectedProcedure);

              this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
              let newLeg2 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
              newLeg2.startPointId = null;
              newLeg2.startPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg2, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg2);
              this.selectCoordinatePointService.selectLegFeature(newLeg2, this.selectCoordinatePointService.selectedProcedure);
            }

            return;

          }else if (this.selectCoordinatePointService.activeChangeEndPoint){
            this.selectCoordinatePointService.activeChangeEndPoint = false;

            let newPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
            newPoint.altitude = 0;
            newPoint.coordPoint = elm;
            const pcpLength = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.length;
            newPoint.sequencenumber = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints[pcpLength-1].sequencenumber + 1;
            //let indexCoordPoint = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.findIndex(elm => elm.procedureCoordPointPk == this.selectCoordinatePointService.selectedProcedureLeg.endPoint.procedureCoordPointPk);
            const indexCoordPoint = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.findIndex(pcp =>
              this.selectCoordinatePointService.selectedProcedureLeg.endPoint.sequencenumber == pcp.sequencenumber);
            if (indexCoordPoint > -1) {
              newPoint.sequencenumber = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints[indexCoordPoint].sequencenumber;
              this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.splice(indexCoordPoint, 1, newPoint);
            }

            //let indexProcedureLeg = this.selectCoordinatePointService.selectedProcedure.procedureLegs.indexOf(this.selectCoordinatePointService.selectedProcedureLeg, 0);
            const indexProcedureLeg = this.selectCoordinatePointService.selectedProcedure.procedureLegs.findIndex(
              leg => leg.procedurelegid == this.selectCoordinatePointService.selectedProcedureLeg.procedurelegid);
            if (indexProcedureLeg == 0) {// first
              this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
              let newLeg1 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
              newLeg1.endPointId = null;
              newLeg1.endPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg1, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg1);
              this.selectCoordinatePointService.selectLegFeature(newLeg1, this.selectCoordinatePointService.selectedProcedure);

              this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg + 1].ismodified = true;
              let newLeg2 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg + 1]);
              newLeg2.startPointId = null;
              newLeg2.startPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg2, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg2);
              this.selectCoordinatePointService.selectLegFeature(newLeg2, this.selectCoordinatePointService.selectedProcedure);
            } else if (indexProcedureLeg == this.selectCoordinatePointService.selectedProcedure.procedureLegs.length - 1) {// last

              this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg].ismodified = true;
              let newLeg : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg - 1]);
              newLeg.endPointId = null;
              newLeg.endPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg);
              this.selectCoordinatePointService.selectLegFeature(newLeg, this.selectCoordinatePointService.selectedProcedure);

            } else {// in between
              this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
              let newLeg1 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
              newLeg1.endPointId = null;
              newLeg1.endPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg1, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg1);
              this.selectCoordinatePointService.selectLegFeature(newLeg1, this.selectCoordinatePointService.selectedProcedure);

              this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg + 1].ismodified = true;
              let newLeg2 : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureLegs[indexProcedureLeg + 1]);
              newLeg2.startPointId = null;
              newLeg2.startPoint = newPoint;
              this.selectCoordinatePointService.addLegToMap(newLeg2, this.selectCoordinatePointService.selectedProcedure);
              this.selectCoordinatePointService.tempProcedureLeg.push(newLeg2);
              this.selectCoordinatePointService.selectLegFeature(newLeg2, this.selectCoordinatePointService.selectedProcedure);
            }

            return;
          } else if (this.selectCoordinatePointService.activeChangeFixPoint){
            this.selectCoordinatePointService.activeChangeAirport = false;

            this.selectCoordinatePointService.activeFixPoint.latitude = elm.latitude;
            this.selectCoordinatePointService.activeFixPoint.longitude = elm.longitude;
            this.selectCoordinatePointService.activeFixPoint.latLonDms.fromLat(elm.latitude);
            this.selectCoordinatePointService.activeFixPoint.latLonDms.fromLon(elm.longitude);
            this.selectCoordinatePointService.arcLength = this.mapService.convertMetersToNauticalMiles(this.selectCoordinatePointService.calculateDistance(this.selectCoordinatePointService.selectedProcedureLeg));
            this.selectCoordinatePointService.radius = this.mapService.convertMetersToNauticalMiles(VicentyToolControlService.calculateDistance(this.selectCoordinatePointService.selectedProcedureLeg.startPoint.coordPoint.latitude,
              this.selectCoordinatePointService.selectedProcedureLeg.startPoint.coordPoint.longitude,elm.latitude,elm.longitude));

            let fixPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
            fixPoint.altitude = 0;

            fixPoint.coordPoint = elm;
            fixPoint.isCurvePoint = false;

            let newProcedureLeg : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
            newProcedureLeg.curvePoints = [];
            newProcedureLeg.fixPoint = fixPoint;
            newProcedureLeg.ismodified = false;
            newProcedureLeg.isstraightleg = false;

            this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
            this.selectCoordinatePointService.calculateCurvePoints(newProcedureLeg);
            this.selectCoordinatePointService.tempProcedureLeg.push(newProcedureLeg);
            this.selectCoordinatePointService.addLegToMap(newProcedureLeg, this.selectCoordinatePointService.selectedProcedure);
            this.selectCoordinatePointService.selectLegFeature(newProcedureLeg, this.selectCoordinatePointService.selectedProcedure);
            return;
          }else {
            let newStartPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
            newStartPoint.altitude = 0;
            newStartPoint.coordPoint = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints[this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.length -1].coordPoint;
            newStartPoint.isCurvePoint = false;
            let newEndPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
            newEndPoint.altitude = 0;
            newEndPoint.coordPoint = elm;
            newEndPoint.isCurvePoint = false;
            let newLeg: ProcedureLegModel = new ProcedureLegModel();
            newLeg.isstraightleg = true;
            newLeg.startPoint = newStartPoint;
            newLeg.endPoint = newEndPoint;
            newLeg.procedurelegid = this.selectCoordinatePointService.getLegId();
            this.selectCoordinatePointService.addLegToMap(newLeg, this.selectCoordinatePointService.selectedProcedure,true,this.selectCoordinatePointService.createProcedureTempID);
            this.selectCoordinatePointService.selectedProcedure.procedureLegs.push(newLeg);
            index = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.length;
          }

        }
        let newProcedureCoordinatePoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
        newProcedureCoordinatePoint.coordPoint = elm;
        newProcedureCoordinatePoint.sequencenumber = index;

        if(elm.empty){
          newProcedureCoordinatePoint.coordPoint.coordpointid = '';
          newProcedureCoordinatePoint.coordPoint.name = '';
          this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.splice(index, 0, newProcedureCoordinatePoint);
        }else {
          this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.splice(index, 0, newProcedureCoordinatePoint);
        }
      }
    });
    if (this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.length > 1){
      const legsWithFixPoint = this.selectCoordinatePointService.getLegsWithFixPoint(this.selectCoordinatePointService.selectedProcedure);
      this.selectCoordinatePointService.deleteProcedureLegsOnMap(this.selectCoordinatePointService.selectedProcedure);
      this.selectCoordinatePointService.selectedProcedure.procedureLegs = [];
      this.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(this.selectCoordinatePointService.selectedProcedure, legsWithFixPoint, this.selectCoordinatePointService.tempProcedureLeg,this.createProcedureTempID);
    }
    this.selectCoordinatePointService.coordinatePointsModal = [];
    this.bsModalRef.hide();
  }

  cancel(){
    this.bsModalRef.hide();
  }


}
